import {
  PaymentCurrencyType,
  PaymentProviderType,
  ProductPurchaseStatusType,
  ProductPurchaseTypeType,
  type ProductPurchasesFilterInputType,
} from "@/types/graphql/partner.generated";
import {
  isEnumValue,
  toIdList,
  toIsoDate,
} from "@/partner/shared/utils/filterValues";

/**
 * Маппинг значений фильтра из querystring (`FilterProvider` -> `qs.parse`) в
 * аргумент запроса покупок. Проверки значений живут в общем модуле
 * `shared/utils/filterValues` (enum'ы, даты, списки id), здесь остаётся
 * только раскладка по полям запроса. Пустой результат отдаётся как
 * `undefined`, а не `{}`: запрос без аргумента ведёт себя как раньше.
 */
export function buildPurchasesFilter(
  filter: Record<string, unknown>
): ProductPurchasesFilterInputType | undefined {
  const result: ProductPurchasesFilterInputType = {};

  if (typeof filter.search === "string" && filter.search) {
    result.search = filter.search;
  }

  if (isEnumValue(ProductPurchaseStatusType, filter.status)) {
    result.status = filter.status;
  }

  if (isEnumValue(ProductPurchaseTypeType, filter.type)) {
    result.type = filter.type;
  }

  if (isEnumValue(PaymentCurrencyType, filter.currency)) {
    result.currency = filter.currency;
  }

  const productIds = toIdList(filter.productIds);
  if (productIds) result.productIds = productIds;

  if (Array.isArray(filter.providers)) {
    const providers = filter.providers.filter(
      (provider): provider is PaymentProviderType =>
        isEnumValue(PaymentProviderType, provider)
    );
    if (providers.length > 0) result.providers = providers;
  }

  const dateFrom = toIsoDate(filter.dateFrom);
  if (dateFrom) result.dateFrom = dateFrom;

  const dateTo = toIsoDate(filter.dateTo);
  if (dateTo) result.dateTo = dateTo;

  return Object.keys(result).length > 0 ? result : undefined;
}
